exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-ruleForm[data-v-4b449f47]  .el-form-item__label{padding-bottom:10px;line-height:20px}", ""]);

// exports
